module.exports = __webpack_public_path__ + "img/h2.a01da115.png";